export default __webpack_public_path__ + "static/media/jet-hero2_converted.0b2812ee.jpg";